import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { OVERVIEW_ROLES } from "./documentationOverviewContent";
import {
  SECTION_EYEBROW,
  SECTION_SPACING,
  SECTION_SUBTITLE,
  SECTION_TITLE,
  TRANSITION_HOVER,
} from "./overviewTokens";

export function RolesSection() {
  return (
    <section aria-labelledby="doc-roles-title" className={SECTION_SPACING} id="roles">
      <p className={SECTION_EYEBROW}>Choose your lane</p>
      <h2 id="doc-roles-title" className={SECTION_TITLE}>
        Who are you using PhiloLMS as?
      </h2>
      <p className={SECTION_SUBTITLE}>
        Pick the role that best matches you. Each guide is written in plain language, with
        screenshots and step-by-step walkthroughs.
      </p>

      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {OVERVIEW_ROLES.map((role) => {
          const Icon = role.icon;
          return (
            <article
              key={role.id}
              className={`group rounded-xl border border-slate-200 bg-white p-6 shadow-xs ${TRANSITION_HOVER}`}
            >
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-transform duration-300 ease-out group-hover:scale-105">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-slate-900">{role.title}</h3>
              </div>

              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{role.whoItIs}</p>

              <ul className="mt-4 space-y-2">
                {role.canDo.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-slate-700">
                    <Check className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={role.startLink.to}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition-transform duration-200 ease-out hover:gap-2"
              >
                {role.startLink.label}
                <ArrowRight className="h-4 w-4" />
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
}
